import React, { Fragment } from 'react';

import HeaderUno from '../Compartidos/HeaderUno';
import HeaderMetodos from '../../AuxiliaresPaginas/HeaderMetodos';

// css
import { Container, BtnsLink } from '../../Css/MetodosCSS/StyledLectura';
import { ContainerFlex } from '../../Css/MetodosCSS/StyledLN2Todos';
import { HrMetodos } from '../../Css/StyledHeader';

const ComprensionLectora = () => {

    return (
        <Fragment>
            <HeaderUno />
            <HrMetodos margin='0 0.2rem 0.5rem 0.2rem' />
            <HeaderMetodos l1={"metodos/"} l2={"lecto-escritura/"} n1={"Métodos"} n2={"LECTURA Y ESCRITURA"} componente={"COMPRENSION LECTORA"} paciente={true} bgcolor="#D05F67" color="white" width='96vw' shadow="0px 4px 4px rgba(0, 0, 0, 0.25)" display="none"/>
            <Container width="100%" height="100%">
                <Container display="flex" justify="center" direction="column" align="center" margin="auto">
                    <ContainerFlex display="flex" align="center">
                        <BtnsLink margin="1rem" padding="40px 40px" font="1.3rem" to={'/escritorio/metodos/lecto-escritura/comprension-lectora/oraciones'}>ORACIONES</BtnsLink>
                    </ContainerFlex>
                </Container>
            </Container>
        </Fragment>
    );
}

export default ComprensionLectora;